import React from 'react';
import { connect } from 'react-redux';
import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { Table } from 'antd';
import { fetchMySalary } from '../../actions/employee-actions';

class MySalary extends React.Component {
	componentWillMount() {
		this.props.fetchMySalary();
	}
	columns = [{title: "Year/month",
	key: "account_monthly",
	dataIndex: "account_monthly",
	className: 'table-global-head'
},{
	title: "Base salary",
	key: "current_base_salary",
	dataIndex: "current_base_salary",
	className: 'table-global-head'
},{
	title: "Position salary",
	key: "current_post_salary",
	dataIndex: "current_post_salary",
	className: 'table-global-head'
},{
	title: '缴纳单位',
	dataIndex: 'pay_unit',
	key: 'pay_unit',
	className: 'table-global-head-short'
},{
	title: "Welfare subsidy",
	key: "welfare_subsidies",
	dataIndex: "welfare_subsidies",
	className: 'table-global-head'
},{
	title: "Personal leave",
	key: "leave_subsidies",
	dataIndex: "leave_subsidies",
	className: 'table-global-head'
},{
	title: "Sick leave",
	key: "sick_leave_subsidies",
	dataIndex: "sick_leave_subsidies",
	className: 'table-global-head'
},{
	title: "Other leave",
	key: "other_holidays",
	dataIndex: "other_holidays",
	className: 'table-global-head'
},{
	title: "No clock in/out deduction",
	key: "not_punched_deduct",
	dataIndex: "not_punched_deduct",
	className: 'table-global-head'
},{
	title: "Tardiness deduction",
	key: "come_late_deduct",
	dataIndex: "come_late_deduct",
	className: 'table-global-head'
},{
	title: "No call/no show deduction",
	key: "stay_away_deduct",
	dataIndex: "stay_away_deduct",
	className: 'table-global-head'
},{
	title: "Salary to be paid",
	key: "wage_payable",
	dataIndex: "wage_payable",
	className: 'table-global-head'
},{
	title: "Personal tax withholding",
	key: "withholding_tax",
	dataIndex: "withholding_tax",
	className: 'table-global-head'
},{
	title: "社保个人",
	key: "social_securitys_personal",
	dataIndex: "social_securitys_personal",
	className: 'table-global-head'
}
// {
// 	title: "Personal retirement fee",
// 	key: "pension_rates_personal",
// 	dataIndex: "pension_rates_personal",
// 	className: 'table-global-head'
// },{
// 	title: "Personal medical fee",
// 	key: "medical_rates_personal",
// 	dataIndex: "medical_rates_personal",
// 	className: 'table-global-head'
// },{
// 	title: "Personal unemployment fee",
// 	key: "unemployment_rates_personal",
// 	dataIndex: "unemployment_rates_personal",
// 	className: 'table-global-head'
// }
,{
	title: "Personal public tax",
	key: "provident_fund_rates_personal",
	dataIndex: "provident_fund_rates_personal",
	className: 'table-global-head'
},{
	title: " Class hours fee",
	key: "class_hour_fee",
	dataIndex: "class_hour_fee",
	className: 'table-global-head'
},{
	title: "Allowance",
	key: "allowance",
	dataIndex: "allowance",
	className: 'table-global-head'
},{
	title: "Subsidy",
	key: "subsidy",
	dataIndex: "subsidy",
	className: 'table-global-head'
},{
	title: "Tax exemption",
	key: "invoice_tax_deduct",
	dataIndex: "invoice_tax_deduct",
	className: 'table-global-head'
},{
	title: "To be paid",
	key: "real_wages",
	dataIndex: "real_wages",
	className: 'table-global-head'
},{
	title: '子女教育支出',
	dataIndex: 'children_education',
	key: 'children_education',
	className: 'table-global-head-6x'
}, {
	title: '继续教育支出',
	dataIndex: 'adult_education',
	key: 'adult_education',
	className: 'table-global-head-6x'
}, {
	title: '住房贷款利息支出',
	dataIndex: 'home_loan_interest',
	key: 'home_loan_interest',
	className: 'table-global-head-8x'
}, {
	title: '住房租金支出',
	dataIndex: 'housing_rents',
	key: 'housing_rents',
	className: 'table-global-head-6x'
}, {
	title: '赡养老人支出',
	dataIndex: 'support_the_old',
	key: 'support_the_old',
	className: 'table-global-head-6x'
}, {
	title: '专项总计',
	dataIndex: 'special_total',
	key: 'special_total',
	className: 'table-global-head-6x'
},{
	title: "Cash",
	key: "cash",
	dataIndex: "cash",
	className: 'table-global-head'
},
{
	title: "代发工资银行1",
	dataIndex: 'payroll_bank',
	key: "payroll_bank",
	className: 'table-global-head-6x'
}, {
	title: "银行2",
	dataIndex: 'bank',
	key: "bank",
	className: 'table-global-head-6x'
}, {
	title: "银行3",
	dataIndex: 'bank2',
	key: "bank2",
	className: 'table-global-head-6x'
},{
	title: "Company health care",
	key: "laobaojian",
	dataIndex: "laobaojian",
	className: 'table-global-head'
},{
	title: "After tax deduction",
	key: "post_tax_deduct",
	dataIndex: "post_tax_deduct",
	className: 'table-global-head'
}]
	fetchMySalary = pagination => {
		this.props.fetchMySalary({page: pagination.current});
	}
	render() {
		return (
			<div className="app-module-item">
				<div className="Attendanceholiday">我的薪资 My Salary</div>
				<div style={{paddingTop:"20px", paddingBottom:"20px"}}>
					<Table columns={this.columns} 
						dataSource={this.props.employee.mySalaryData}
						pagination={{total: this.props.employee.mySalaryTotalPage,
							defaultCurrent: 1,
							pageSize: this.props.employee.mySalaryPageSize,
							current: this.props.employee.mySalaryPage}}
						scroll={{x: 1010}}
						onChange={this.fetchMySalary.bind(this)}
						rowKey={record => record.id} 
					 />					
				</div>
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		employee: state.employee
	}
}

const mapDispatchToProps = {
	fetchMySalary
}


export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(MySalary));


// WEBPACK FOOTER //
// ./src/routes/Employee/MySalaryEn.js